import { SendMessageInputProps } from './types';

export const SendMessageInput = ({ children }: SendMessageInputProps) => (
    <div data-testid="chatMsgInput" className="relative flex max-w-2xl mx-auto px-6 py-2">
        {children}
    </div>
);
